import { useAppSelector } from "redux/hooks";
import { selectClientLens, selectClientLensCaseFilters } from "redux/slices/clientLens";

import BreadcrumbDropdownPicker, { BreadcrumbDropdownPickerOption } from "./BreadcrumbDropdownPicker";
import { selectMyUserType } from "redux/slices/session";
import { UserType } from "generated/graphql";
import { AppRoutes } from "AppRoutes";

interface LensSubnavBreadcrumbProps {
  route: string;
  routeTitle: string;
}

export const LensSubnavBreadcrumb = (props: LensSubnavBreadcrumbProps) => {
  const clientLens = useAppSelector(selectClientLens);
  const userType = useAppSelector(selectMyUserType);
  const isReviewer = userType === UserType.Reviewer;
  const caseFiltersParams = useAppSelector(selectClientLensCaseFilters);
  let options: BreadcrumbDropdownPickerOption[] = [
    {
      title: "Cases",
      route: `/lens/${clientLens.id}/cases`,
      searchParamsString: caseFiltersParams ? `?${caseFiltersParams}` : undefined,
      uniqueId: "cases",
    },
  ];

  if (!isReviewer) {
    options = options.concat([
      {
        title: "Reports",
        route: AppRoutes.lensReportsBuilder(clientLens.id),
        uniqueId: "reports",
      },
      {
        title: "Files",
        route: AppRoutes.lensFilesBuilder(clientLens.id),
        uniqueId: "files",
      },
      {
        title: "Import Cases",
        route: AppRoutes.lensCaseImportBuilder(clientLens.id),
        uniqueId: "import_cases",
      },
      {
        title: "Case Profile Exports",
        route: AppRoutes.lensExportConfigBuilder(clientLens.id, undefined),
        uniqueId: "export_config",
      },
    ]);
  }

  return (
    <BreadcrumbDropdownPicker
      pendoId="breadcrumb-lenshome::cases/reports/files/import-cases"
      search={false}
      label={props.routeTitle}
      noResultsText={undefined}
      currentRoute={`${AppRoutes.lensHomeBuilder(clientLens.id)}/${props.route}`}
      options={options}
    />
  );
};
